import { Component, OnInit } from '@angular/core';

@Component
({
  selector: 'site.detail.page',
  templateUrl: './site.detail.page.html',
  styleUrls: ['./site.detail.page.scss']
})

export class SiteDetailPage implements OnInit 
{
  ngOnInit(): void 
  {}
}
